<mat-card class="facility-roles-card">
  <mat-card-header>
    <mat-card-title>Facility Roles</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    
    <div *ngIf="showNoResults" class="no-results-message">
      <mat-icon>search_off</mat-icon>
      <p>No results were found from your search</p>
    </div>

    <!-- Table View -->
    <div *ngIf="!showDetailView && !showNoResults">
      <div class="teammate-facility-filter">
        <mat-form-field appearance="outline" class="full-width-field">
          <mat-label>Filter Roles</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Filter by any column..." #input>
        </mat-form-field>
      </div>
      
      <div class="teammate-facility-table mat-elevation-z8">
        <table mat-table [dataSource]="facilityRolesTableData">
          
          <!-- Facility Info Column -->
          <ng-container matColumnDef="facilityName">
            <th mat-header-cell *matHeaderCellDef>Facility Name</th>
            <td mat-cell *matCellDef="let teammate">{{teammate.facilityName}}</td>
          </ng-container>
      
          <ng-container matColumnDef="facilityId">
            <th mat-header-cell *matHeaderCellDef>Facility ID</th>
            <td mat-cell *matCellDef="let teammate">{{teammate.facilityId}}</td>
          </ng-container>
      
          <ng-container matColumnDef="facilityCity">
            <th mat-header-cell *matHeaderCellDef>City</th>
            <td mat-cell *matCellDef="let teammate">{{teammate.city}}</td>
          </ng-container>
      
          <ng-container matColumnDef="facilityState">
            <th mat-header-cell *matHeaderCellDef>State</th>
            <td mat-cell *matCellDef="let teammate">{{teammate.state}}</td>
          </ng-container>
      
          <mat-header-row *matHeaderRowDef="displayedColumnsFacilities"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumnsFacilities;" 
                   (click)="onRowClick(row)" 
                   class="clickable-row"></mat-row>
        </table>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<!-- Detailed View -->
<div *ngIf="showDetailView && selectedTeammate" class="detail-view">
  <div class="detail-header">
    <button mat-icon-button (click)="onBackToTable()" class="back-button">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h3>Facility Role Details</h3>
  </div>
  
  <mat-card class="results-card">
    <mat-card-header>
      <mat-card-title>Teammate Information</mat-card-title>
    </mat-card-header>
    <mat-card-content class="info-grid">
      <div class="info-item"><strong>Facility Name:</strong> <span>{{selectedTeammate.facilityName}}</span></div>
      <div class="info-item"><strong>City:</strong> <span>{{selectedTeammate.city}}</span></div>
      <div class="info-item"><strong>State:</strong> <span>{{selectedTeammate.state}}</span></div>
      <div *ngIf="isTeammateProfileArray; else profileObject">
        <div *ngFor="let profile of selectedTeammate.profiles; let i = index" class="info-grid">
          <div class="info-item"><strong>Profile Name:</strong> <span>{{profile.profileName}}</span></div>
          <div class="info-item"><strong>Profile ID:</strong> <span>{{profile.profileId}}</span></div>
        </div>
      </div>
      <ng-template #profileObject>
        <div class="info-item"><strong>Profile Name:</strong> <span>{{selectedTeammate.profiles.profileName}}</span></div>
        <div class="info-item"><strong>Profile ID:</strong> <span>{{selectedTeammate.profiles.profileId}}</span></div>
      </ng-template>

    </mat-card-content>
  </mat-card>
